import { validatenull } from "@/util/validate.js";
import menus from "@/util/menus.js";

let formatRoutes = function (aMenu) {
    const aRouter = [];
    aMenu.forEach(function (oMenu) {
        if (!oMenu.pathName) {
            return;
        }
        let newPath = oMenu.pathName.replace(/\./g, "/");
        let newresolve = newPath;
        var nameList = oMenu.pathName.split(".");
        var path = nameList[nameList.length - 1];
        if (!validatenull(newresolve)) {
            let oRouterPath = "/" + path
            const oRouter = {
                path: oRouterPath,
                component: () => import(`@views/${newresolve}.vue`),
                name: oMenu.title,
                icon: "",
                baseMenu: true,
                meta: {
                    title: oMenu.title,
                    breadcrumb: {
                        id: oMenu.id,
                        pathName: oMenu.pathName,
                    },
                },
                children: validatenull(oMenu.children) ? [] : formatRoutes(oMenu.children, type),
            };
            aRouter.push(oRouter);
        }
    });
    return aRouter;
}

export default {
    //获取菜单缓存
    getMenu_cache() {
        return menus;
    },
    //格式化菜单数据
    formatRoutes(aMenu) {
        //构建菜单
        return formatRoutes(aMenu);
    },
}
